import client from 'helpers/client';
import cognito from 'helpers/cognito';

const authHeaders = async () => ({ headers: await cognito.getHeaderAuthorization() });

export const getPublicDistributionBatches = async (filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, value);
    }
  });
  const query = params.toString();
  const response = await client.api(`/distribution-batches/transparency${query ? `?${query}` : ''}`, 'get');
  return response.data;
};

/** Fetch every distribution batch for a DAO (paginates at API max 100 per request). */
export const fetchAllPublicDistributionBatches = async (filters = {}) => {
  const pageSize = 100;
  let page = 1;
  let totalPages = 1;
  const all = [];

  do {
    const res = await getPublicDistributionBatches({ ...filters, page, limit: pageSize });
    const chunk = res?.data || [];
    all.push(...chunk);
    totalPages = res?.pagination?.totalPages || 1;
    page += 1;
  } while (page <= totalPages);

  return all;
};

export const getDistributionBatches = async (filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, value);
    }
  });
  const query = params.toString();
  const response = await client.api(`/distribution-batches${query ? `?${query}` : ''}`, 'get', await authHeaders());
  return response.data;
};

export const getDistributionBatchById = async (id) => {
  const response = await client.api(`/distribution-batches/${id}`, 'get', await authHeaders());
  return response.data;
};

export const createDistributionBatch = async (body) => {
  const response = await client.api('/distribution-batches', 'post', body, await authHeaders());
  return response.data;
};

export const executeDistributionBatch = async (id, body) => {
  const response = await client.api(`/distribution-batches/${id}/execute`, 'post', body, await authHeaders());
  return response.data;
};

export const cancelDistributionBatch = async (id) => {
  const response = await client.api(`/distribution-batches/${id}/cancel`, 'post', {}, await authHeaders());
  return response.data;
};
